import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SingleSelectDropdownModule } from 'Angular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class HoldingsDatePickerInlineModule {
}
HoldingsDatePickerInlineModule.ɵfac = function HoldingsDatePickerInlineModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsDatePickerInlineModule)(); };
HoldingsDatePickerInlineModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HoldingsDatePickerInlineModule });
HoldingsDatePickerInlineModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule, SingleSelectDropdownModule, IconModule, DisabledModule] });
